import React from 'react';
import { Stack, Text } from '@moda/om';
import { useReturnSummary } from '../../../hooks/useReturnSummary';
import { PaymentSummaryRow } from '../PaymentSummaryRow';
import { formatNumber } from '../../../lib/formatNumber';

import './RefundSummary.scss';

interface Props {
  shipmentNumber?: string;
  orderNumber?: string;
}

export const RefundSummary: React.FC<Props> = ({ shipmentNumber, orderNumber }) => {
  const { returnSummary } = useReturnSummary({ shipmentNumber, orderNumber });
  if (!returnSummary) return null;

  const {
    attributes: {
      currencyUnit,
      refundDetails,
      totalRefundAmount,
      taxes,
      taxDetails: { taxType }
    }
  } = returnSummary;

  return (
    <Stack space={3}>
      <Stack space={4} className="RefundSummary">
        <Text treatment="h5" family="serif">
          Refund Summary
        </Text>
        <Stack space={3}>
          {refundDetails.map(({ paymentMethod, amount }, index) => (
            <PaymentSummaryRow
              key={index}
              label={paymentMethod}
              value={
                <>
                  {currencyUnit}
                  {formatNumber(amount)}
                </>
              }
            />
          ))}
          <PaymentSummaryRow
            label={taxType}
            value={
              <>
                {currencyUnit}
                {formatNumber(taxes)}
              </>
            }
          />
        </Stack>
        <div className="RefundSummary__total">
          <PaymentSummaryRow
            label="Total Refund"
            value={
              <>
                {currencyUnit}
                {formatNumber(totalRefundAmount)}
              </>
            }
          />
        </div>
      </Stack>
      <Text color="cement">*Initial shipping charges are non-refundable</Text>
    </Stack>
  );
};
